//FROMCDN
await themeComponent(theme.components['mc-element'],false);
//await themeResource(theme.resources['mc-events'], false);

class McReadMore extends McElement {
  expanded; expandible; link; text; observer;

  connectedCallback(){
    this.text = this.querySelector(':scope > div');
    if(!this.text){ console.error('McReadMore: You need to provide a div element'); return; }
    if(!this.dataset.moreText){ console.error('McReadMore: You need to provide a data-more-text attribute'); return; }
    if(!this.dataset.lessText) { console.error('McReadMore: You need to provide a data-less-text attribute'); return; }

    this.whenStylesReady().then(() => {
      this.observer = new ResizeObserver(() => this.checkExpandible());
      this.observer.observe(this);
      this.checkExpandible();
    });

    this.addEventListener(MCEVENTS.EL_ACTIVATED, this.setText.bind(this));
    this.addEventListener(MCEVENTS.EL_DEACTIVATED, this.setText.bind(this));
  }

  whenStylesReady() {
    return new Promise(r => requestAnimationFrame(() => r()));
  }

  checkExpandible = () => {
    if(this.offsetParent !== null){
      this.expanded = false;
      this.expandible = this.text.scrollHeight > this.text.clientHeight;
      console.log('McReadMore: Expandible:', this.expandible, this.text.scrollHeight, this.text.clientHeight, this.text);
      if(this.expandible){
        this.addLink();
      }
      this.observer.disconnect();
    }
  }

  addLink = () => {
    const classes = this.dataset.classes?.split(' ') || ["read-more-link"];
    this.link = document.createElement('mc-btn');
    this.link.setAttribute('data-target', this.getSelector());
    this.link.innerText = this.dataset.moreText;
    this.link.classList.add(...classes);
    this.appendChild(this.link);
  }

  setText = () => {
    if(this.expandible && this.link){
      if(this.isActive()){
        this.link.innerText = this.dataset.lessText;
      } else {
        this.link.innerText = this.dataset.moreText;
      }
    }
  }
}
if (!window.customElements.get("mc-read-more")) {
  window.customElements.define("mc-read-more", McReadMore);
  //McUtils.addCss(`https://cdn.jsdelivr.net/npm/ict-shopify@${McUtils.VERSION}/v2/css/mc-read-more.css`);
}
window.McReadMore = McReadMore;
export default McReadMore;